module.exports = __webpack_public_path__ + "img/zykfpt.25b02b9e.png";